import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {TreeDataService} from 'src/app/services/tree-data.service';
import {MatDialog} from '@angular/material/dialog';
import {Observable} from 'rxjs';
import {AutocompleteItemPlace} from 'src/app/model/event/place/autocomplete-item-place';
import {TreeItemNode} from 'src/app/model/tree/tree-item-node.model';
import {Event} from 'src/app/model/event/event.model';
import {map, startWith, takeUntil} from 'rxjs/operators';
import {SexeEnum} from 'src/app/model/enums/sexe.enum';
import {YoungCreationDataService} from 'src/app/services/young-creation-data.service';
import {EventWebservice} from 'src/app/services/webservices/event.webservice';
import {DialogSelectCenterComponent} from 'src/app/utils/dialog/dialog-select-center/dialog-select-center.component';
import {isNotNullOrUndefined} from '../../../utils/utils.static';
import {Destroyed} from '../../../utils/directives/destroyed.directive';
import { MatButtonModule } from '@angular/material/button';
import { GridEventMultiSelectComponent } from '../../../utils/ag-grid/grid-event-multi-select/grid-event-multi-select.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatOptionModule } from '@angular/material/core';
import { NgFor, AsyncPipe } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';


@Component({
    selector: 'app-inscription-add-supp-register-event',
    templateUrl: './inscription-add-supp-register-event.component.html',
    styleUrls: ['./inscription-add-supp-register-event.component.scss'],
    imports: [MatCardModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatAutocompleteModule, NgFor, MatOptionModule, MatIconModule, MatExpansionModule, GridEventMultiSelectComponent, MatButtonModule, AsyncPipe]
})
export class InscriptionAddSuppRegisterEventComponent extends Destroyed implements OnInit {
  private readonly fb = inject(UntypedFormBuilder);
  private readonly treeDataService = inject(TreeDataService);
  private readonly dialog = inject(MatDialog);
  private readonly youngCreationDataService = inject(YoungCreationDataService);
  private readonly eventWS = inject(EventWebservice);


  @Input() submitted: boolean;
  @Input() disabled: boolean;
  @Input() birthday: Date;
  @Input() sex: SexeEnum;
  @Input() defaultSelection: Event[] = [];
  @Input() centerId: number;
  @Input() index: number;
  @Input() idUser: number;

  @Output() removeComponent = new EventEmitter<number>();

  formGroup: UntypedFormGroup;
  filteredPlace: Observable<AutocompleteItemPlace[]>;
  fullPlaceList: AutocompleteItemPlace[] = [];
  excludePlaceList: TreeItemNode[];
  eventList: Event[] = [];

  defaultPlace: TreeItemNode;

  placeId: number = 0;

  ngOnInit() {
      this.formGroup = this.fb.group(
          {
              place: [null]
          }
      );

      this.initPlaceSelector();

      this.filteredPlace = this.formGroup.controls.place.valueChanges
          .pipe(
              startWith(''),
              map(value => {
                  return this._filterFullPlaceList(value);
              })
          );

      this.formGroup.controls.place.valueChanges.pipe(takeUntil(this.destroyed)).subscribe(
          value => {
              const searchPlace = this.fullPlaceList.find(item => item.place.name === value);
              if (searchPlace) {
                  // Recupere la liste des regEvent pour la place
                  this.eventWS.getEventTypes(this.birthday, this.sex, this.placeId, this.idUser).subscribe(events => {
                      this.eventList = events;
                  });
              }
          });

      this.treeDataService.allExcludePlacesMessager
          .pipe(takeUntil(this.destroyed))
          .subscribe(data => {
              this.excludePlaceList = data;
          });
  }

  initPlaceSelector() {
      this.treeDataService.allPlacesMessager.pipe(takeUntil(this.destroyed)).subscribe((data: TreeItemNode[]) => {
          this.getChildPlaces(data);

          if (this.centerId) {
              const searchPlace = this.fullPlaceList.find(item => item.place.id === this.centerId);
              if (searchPlace) {
                  this.treeDataService.addExcludePlace(searchPlace.place);
                  this.formGroup.controls.place.setValue(searchPlace.place.name);
              }
          }
      });
  }

  openModal() {
      if (this.formGroup.enabled) {
          const dialogRef = this.dialog.open(DialogSelectCenterComponent, {
              panelClass: 'dialog'
          });
          dialogRef.afterClosed().pipe(takeUntil(this.destroyed)).subscribe((value: TreeItemNode) => {
              // Ajoute le centre aux exclus
              if (value?.id) {
                  if (this.placeId) {
                      this.treeDataService.removeExcludePlace(this.placeId);
                      this.placeId = value.id;
                      this.treeDataService.addExcludePlace(value);
                  } else {
                      this.treeDataService.addExcludePlace(value);
                      this.placeId = value.id;
                  }

                  // Recharge la liste pour le bug suppression de centre (disparition de centre)

                  this.formGroup.controls.place.setValue(value.name);
              }
          });
      }
  }

  onSelectionChange(event) {
      this.youngCreationDataService.setRegisterEvent(event, this.placeId);
  }

  onRemovePlace() {
      if (this.placeId) {
          this.treeDataService.removeExcludePlace(this.placeId);
      }
      this.removeComponent.emit(this.index);
      this.youngCreationDataService.removeRegisterEvent(this.placeId);
  }

  private _filterFullPlaceList(value: string): AutocompleteItemPlace[] {
      if (typeof (value) === 'string') {
          const filterValue = value.toLowerCase();
          return this.fullPlaceList.filter(item => item.place.name.toLowerCase().includes(filterValue) && !item.place.listOfChilds && item.isActive && !this.excludePlaceList.find(excludeItem => excludeItem.id === item.place.id));
      }
      return null;
  }

  private getChildPlaces(placeList: TreeItemNode[]) {
      placeList.forEach(place => {
          this.fullPlaceList.push({place: place, isActive: true});
          if (isNotNullOrUndefined(place.listOfChilds)) {
              this.getChildPlaces(place.listOfChilds);
          }
      });
  }
}
